import { createContext, useState, useContext } from 'react'
import { IntakeContext } from 'context/IntakeContext'
// export interface AltruistOpenRothType {
//   currModalCard: number,
//   setCurrModalCard: Function,
//   modalOpen: boolean,
//   setModalOpen: Function
// }

export const AltruistOpenRothContext = createContext(null)

const AltruistOpenRothProvider = ({ children }) => {
  const { intakeState } = useContext(IntakeContext)
  const [currModalCard, setCurrModalCard] = useState(0)
  const [modalOpen, setModalOpen] = useState(false)
  const [emailAltruist, setEmailAltruist] = useState(intakeState.email)

  // console.log(emailAltruist)
  return (
    <AltruistOpenRothContext.Provider
      value={{
        currModalCard,
        setCurrModalCard,
        modalOpen,
        setModalOpen,
        emailAltruist,
        setEmailAltruist,
      }}
    >
      {children}
    </AltruistOpenRothContext.Provider>
  )
}

export default AltruistOpenRothProvider
